import React from 'react'
import { IconButton } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp'
import { Card, BarChart, Text } from '@tremor/react'

const data = [
  { mes: 'Abril', nivel1: 1200, nivel2: 800, nivel3: 400 },
  { mes: 'Mayo', nivel1: 1800, nivel2: 1200, nivel3: 1200 },
  { mes: 'Junio', nivel1: 1500, nivel2: 1100, nivel3: 900 },
  { mes: 'Julio', nivel1: 1400, nivel2: 1100, nivel3: 900 },
  { mes: 'Agosto', nivel1: 900, nivel2: 1300, nivel3: 1100 },
  { mes: 'Septiembre', nivel1: 1600, nivel2: 1200, nivel3: 900 },
  { mes: 'Octubre', nivel1: 900, nivel2: 1300, nivel3: 1100 },
  { mes: 'Noviembre', nivel1: 900, nivel2: 1300, nivel3: 1800 },
  { mes: 'Diciembre', nivel1: 900, nivel2: 1300, nivel3: 1100 },
  { mes: 'Enero', nivel1: 900, nivel2: 900, nivel3: 600 },
  { mes: 'Febrero', nivel1: 700, nivel2: 700, nivel3: 900 },
  { mes: 'Marzo', nivel1: 1100, nivel2: 900, nivel3: 900 },
  { mes: 'Abril', nivel1: 900, nivel2: 700, nivel3: 600 },
]

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

const downloadCSV = () => {
  const csvRows = [
    ['Mes', 'Nivel 1', 'Nivel 2', 'Nivel 3'],
    ...data.map(row => [row.mes, row.nivel1, row.nivel2, row.nivel3]),
  ]
  const csvContent = csvRows.map(e => e.join(',')).join('\n')
  const blob = new Blob([csvContent], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = 'evolucion_registros_nivel.csv'
  a.click()
  URL.revokeObjectURL(url)
}

export const LevelRegistrationEvolution = () => (
  <Card className="p-8">
    <div className="flex flex-row justify-between items-start mb-2">
      <div>
        <Text className="text-lg font-bold mb-2" style={montserratStyle}>
          Evolución de registros por nivel
        </Text>
        <div className="flex gap-4 items-center mb-2">
          <div className="flex items-center gap-2">
            <span
              style={{
                width: 16,
                height: 16,
                background: '#C9D296',
                borderRadius: 4,
                display: 'inline-block',
              }}
            />
            <span style={montserratStyle}>Nivel 1</span>
          </div>
          <div className="flex items-center gap-2">
            <span
              style={{
                width: 16,
                height: 16,
                background: '#F29569',
                borderRadius: 4,
                display: 'inline-block',
              }}
            />
            <span style={montserratStyle}>Nivel 2</span>
          </div>
          <div className="flex items-center gap-2">
            <span
              style={{
                width: 16,
                height: 16,
                background: '#E8B342',
                borderRadius: 4,
                display: 'inline-block',
              }}
            />
            <span style={montserratStyle}>Nivel 3</span>
          </div>
        </div>
      </div>
      <IconButton className="ml-2" aria-label="download" onClick={downloadCSV}>
        <GetAppIcon />
      </IconButton>
    </div>
    <div id="bar-chart-niveles" className="mt-2">
      <BarChart
        data={data}
        index="mes"
        categories={['nivel1', 'nivel2', 'nivel3']}
        colors={['green', 'emerald', 'lime']}
        showLegend={false}
        showGridLines
        yAxisWidth={40}
        stack
        style={{ fontFamily: 'Montserrat, sans-serif' }}
      />
    </div>
  </Card>
)
